import { render, staticRenderFns } from "./RolesTable.vue?vue&type=template&id=686e7ca1"
import script from "./RolesTable.vue?vue&type=script&lang=js"
export * from "./RolesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports